/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RecommendsItem,
    RecommendsItemFromJSON,
    RecommendsItemToJSON,
} from './';

/**
 *
 * @export
 * @interface Recommends
 */
export interface Recommends {
    /**
     *
     * @type {string}
     * @memberof Recommends
     */
    title: string;
    /**
     *
     * @type {Array<RecommendsItem>}
     * @memberof Recommends
     */
    recommend: RecommendsItem[];
}

export function RecommendsFromJSON(json: any): Recommends {
    return RecommendsFromJSONTyped(json, false);
}

export function RecommendsFromJSONTyped(json: any, _: boolean): Recommends {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'recommend': ((json['recommend'] as any[]).map(RecommendsItemFromJSON)),
    };
}

export function RecommendsToJSON(value?: Recommends | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'recommend': ((value.recommend as any[]).map(RecommendsItemToJSON)),
    };
}
